let url;

if (process.env.REACT_APP_API_URL) {
  // Local/dev override (e.g. point at a locally-run backend). No-op unless
  // REACT_APP_API_URL is set, so production/staging/dev builds are unaffected.
  url = process.env.REACT_APP_API_URL;
} else if (process.env.REACT_APP_ENVIRONMENT === "production") {
  url = "https://brightstar-api.webtime.us/api";
} else if (process.env.REACT_APP_ENVIRONMENT === "staging") {
  url = "https://brightstar-staging-api.webtime.us/api";
} else {
  url = "https://brightstar-dev-api.webtime.us/api";
}

export default url;
